import FileUploader from 'devextreme-react/file-uploader';
import { toast } from 'react-toastify';
import { Config } from '@/core/config/config';
import { useState } from 'react';
import { setProfileImageUploaded } from '@/store/upload/upload-slice';
import { useDispatch } from 'react-redux';
const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/document/upload/profile-image-upload`;

const ProfileImageUploader = () => {
  const dispatch = useDispatch();
  const [uploaderKey, setUploaderKey] = useState(Date.now());
  const handleUploadError = (e: any) => {
    try {
      const response = JSON.parse(e?.request?.response);
      const errorMessage = response?.message;
      if (response?.status === 400) {
        toast.warning(errorMessage);
      }
    } catch (err: any) {
      toast.error(err);
    }
  }
  const onBeforeSend = (e: any) => {
    const token = localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string);
    if (token) {
      e.request.setRequestHeader("Authorization", `Bearer ${token}`);
    }
  };

  return (
    <FileUploader
      key={uploaderKey}
      selectButtonText="Dosya Seç"
      labelText="Profil fotoğrafınızı yükleyin"
      multiple={false}
      uploadMode="instantly"
      name="Body.File"
      uploadUrl={uploadUrl}
      accept=".jpg,.jpeg,.png"
      onBeforeSend={onBeforeSend}
      onUploaded={() => {
        toast.success("Yükleme başarılı!");
        dispatch(setProfileImageUploaded(true));
        setUploaderKey(Date.now());
      }}
      onUploadError={handleUploadError}
    />
  );
};

export default ProfileImageUploader;
